import {Component, HostListener, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {EventPublishService} from '../services/event-publish.service';

@Component({
  selector: 'app-event-schedule',
  templateUrl: './event-schedule.component.html',
  styleUrls: [ './event-schedule.component.scss' ]
})
export class EventScheduleComponent implements OnInit {

  public activeImage = true;
  private intervalId: any;

  // public banner_sponsor = "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Fbanner_sponsors%2Fbanner_1751897354888.png?alt=media&token=32058e28-edc4-43b3-a3fa-c1e2e35b3815";
  public key: string = ''
  public event: any = {}
  public loading: boolean = false;

  public criteria: string = '';

  public activities: any[] = []
  public _activities: any[] = []

  public days: any[] = [];
  public rooms: any[] = [];
  public deptos: any[] = [];
  public speakers: any[] = []

  public selectedDepto: any;
  public selectedRoom: any;
  public selectedDay: any;
  public selectedSpeaker: any;
  public selectDays: any[] = [];
  public isSpeaker: boolean = false;
  public isDepto: boolean = false;

  public member_name: string;
  public member_text: string;
  public member_image: string;

  public depto_text: string;
  public currentImage: any;

  public notFound: boolean = false;

  constructor (
    private _route: ActivatedRoute,
    private _eventPublishService: EventPublishService,
  ) {
    this.key = this._route.snapshot.paramMap.get('key');
    if (this.key === "51congresso") this.key = "51Congresso"

    this.clearFilters();
    this.getData(this.key)
  }

  ngOnInit () {
    this.intervalId = setInterval(() => {
      this.toggleImage();
    }, 5000);
  }

    toggleImage () {
    this.activeImage = !this.activeImage;
  }

  async getData (key: any) {
    this.event = await this._eventPublishService.getMasterEventByKey(key)
    this.activities = await this._eventPublishService.getSchedule(this.event.context_id);
    this._activities = this.activities;

    this.resizeWindow(window.innerWidth);
    this.loadFilters(this.activities)

    console.log("atividades: " + JSON.stringify(this.activities))

  }

  loadFilters (activities) {

    this.days.push({"id": "-Todos os dias", "name": "-Todos os dias"})
    this.rooms.push({"id": "-Todas as salas", "name": "0 - -Todas as salas"})
    this.deptos.push({"id": "-Todas as atividades", "name": "-Todas as atividades"})
    this.speakers.push({"id": "-Todos os palestrantes", "name": "-Todos os palestrantes"})

    activities.forEach((activity) => {
      this.checkDays(activity)
      this.checkLocation(activity)
      this.checkDeptos(activity)
      this.checkSpeakers(activity)
    })

    /*
    console.log("days -------------------")
    console.log(JSON.stringify(this.days))
    console.log("locations -------------------")
    console.log(JSON.stringify(this.rooms))
    console.log("deptos -------------------")
    console.log(JSON.stringify(this.deptos))
    console.log("spealers -------------------")
    console.log(JSON.stringify(this.speakers))
    */
  }

  checkDays (activity: any) {
    const day = {
      'id': activity.date,
      'name': activity.date
    }
    const dayExist = this.days.find((e) => {
      return e.id === day.id
    })
    if (!dayExist) {
      this.days.push(day)
    }
  }

  checkLocation (activity) {
    const location = {
      'id': activity.location_id,
      'name': activity.location
    }
    const roomExist = this.rooms.find((e) => {
      return e.id === location.id
    })
    if (!roomExist) {
      this.rooms.push(location)
    }
    this.rooms.sort(this._eventPublishService.compareNames)
  }

  checkDeptos (activity) {
    const depto = {
      'id': activity.depto_id,
      'name': activity.depto
    }
    const deptoExist = this.deptos.find((e) => {
      return e.id === depto.id
    })
    if (!deptoExist) {
      this.deptos.push(depto)
    }
    this.deptos.sort(this._eventPublishService.compareNames)
  }

  checkSpeakers (activity) {
    //console.log('checkSpeakers ' + JSON.stringify(activity))
    activity.agenda.forEach((activity_ag) => {
      // console.log('checkactivity_ag: ' + JSON.stringify(activity_ag))
      this.addSpeaker(activity_ag)
    })

    if (activity.topics) {
      activity.topics.forEach((topic) => {

        topic.agenda.forEach((topic_ag) => {
          this.addSpeaker(topic_ag)
        })

      })
    }

    this.speakers.sort(this._eventPublishService.compareNames)

  }

  addActivity (activity) {

    const exist = this._activities.find((e) => {
      return e.id === activity.id
    })
    if (!exist) {
      this._activities.push(activity)
    }
  }

  addSpeaker (data) {

    const speaker = {
      'id': data.member_id,
      'name': data.member_name,
      'statge': data.member_state
    }
    const existSpeaker = this.speakers.find((e) => {
      return e.id === speaker.id
    })
    if (!existSpeaker) {
      this.speakers.push(speaker)
    }

  }

  selectDay (event: any) {
    if (event == "-Todos os dias") {
      this.selectedDay = "-Todos os dias";
    } else {
      this.selectedDay = event
    }
  }

  selectRoom (event: any) {
    if (event == "-Todas as salas") {
      this.selectedRoom = "-Todas as salas";
    } else {
      this.selectedRoom = event
    }
  }

  selectDepartent (event: any) {
    if (event == "-Todas as atividades") {
      this.selectedDepto = "-Todas as atividades";
    } else {
      this.selectedDepto = event
    }
  }

  selectSpeaker (event: any) {
    if (event == "-Todos os palestrantes") {
      this.selectedSpeaker = null;
    } else {
      this.selectedSpeaker = event;
    }
  }

  filter () {
    let ctrl = false;
    this._activities = [];

    this.activities.forEach(activity => {
      let setArray: any[] = [];
      setArray.push({"criteria": this.selectedDay, "result": true});
      setArray.push({"criteria": this.selectedRoom, "result": true});
      setArray.push({"criteria": this.selectedDepto, "result": true});
      setArray.push({"criteria": this.selectedSpeaker, "result": true});

      if (setArray[ 0 ].criteria !== "-Todos os dias") {
        if (activity.date === this.selectedDay) {
          setArray[ 0 ].result = true;
        } else {
          setArray[ 0 ].result = false;
        }
      }

      if (setArray[ 1 ].criteria !== "-Todas as salas") {
        if (activity.location_id === this.selectedRoom) {
          setArray[ 1 ].result = true;
        } else {
          setArray[ 1 ].result = false;
        }
      }

      if (setArray[ 2 ].criteria !== "-Todas as atividades") {
        if (activity.depto_id === this.selectedDepto) {
          setArray[ 2 ].result = true;
        } else {
          setArray[ 2 ].result = false;
        }
      }

      if (setArray[ 3 ].criteria !== "-Todos os palestrantes") {

        if (activity.agenda.length > 0) {

          for (const aga of activity.agenda) {

            if (aga.member_id == this.selectedSpeaker) {

              setArray[ 3 ].result = true;
              break;

            } else {
              setArray[ 3 ].result = false;
            }

          }


        } else {
          setArray[ 3 ].result = false;
        }

        if (activity.topics.length > 0) {
          for (const topic of activity.topics) {
            if (topic.agenda.length > 0) {

              for (const agt of topic.agenda) {
                if (agt.member_id == this.selectedSpeaker) {
                  setArray[ 3 ].result = true;
                }
              }

            } else {
              setArray[ 3 ].result = false;
              //break;
            }

            if (setArray[ 3 ].result == true) {
              break;
            }

          }

        } else {
          //setArray[ 3 ].result = false;
        }

      }

      for (const item of setArray) {

        if (item.result) {
          ctrl = true;
        } else {
          ctrl = false;
          break;
        }
      }

      if (ctrl) {
        this.addActivity(activity);
      }

    })

    if (this._activities.length > 0) {
      this.notFound = false;
      if (this.selectedSpeaker !== "-Todos os palestrantes") {
        this.isSpeaker = true;
        this._eventPublishService.getSpeakerData(this.selectedSpeaker)
          .subscribe((result) => {
            this.member_name = result.data().name;
            this.member_text = result.data().text;
            this.member_image = result.data().image;
            this.criteria = this.member_name ;
          })
      } else {
        this.isSpeaker = false;
        this.member_name = "";
        this.member_text = "";
        this.member_image = "";
        this.criteria = "";
      }
    } else {
      this.clearSpeaker();
      this.notFound = true;
    }

  }

  clearFilters () {
    this.selectedDay = "-Todos os dias";
    this.selectedRoom = "-Todas as salas";
    this.selectedDepto = "-Todas as atividades";
    this.selectedSpeaker = "-Todos os palestrantes";
    this.criteria = ""
    this.notFound = false;
    this._activities = this.activities;
    this.clearSpeaker();
  }

  clearSpeaker () {
    this.isSpeaker = false;
    this.member_name = "";
    this.member_text = "";
    this.member_image = "";
    this.criteria = "";
  }

  @HostListener('window:resize', [ '$event' ]) onWindowResize (e) {
    this.resizeWindow(window.innerWidth);
  }

  resizeWindow (width) {
    if (width < 600) {
      this.currentImage = this.event.image_mobile
    } else {
      this.currentImage = this.event.image_web
    }

   // console.log("this.currentImage: " + this.currentImage)
  }

}
